export enum QuotaOperation {
  Swap = 'swap',
  Withdrawal = 'withdrawal',
}
